module.exports = __webpack_public_path__ + "img/icon_4_19.25477942.png";